<template>
    <div>
        <div class="header-wrapper">
            <header class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <priorities-carousel></priorities-carousel>

        <div class="review">
            <div class="container">
                <div class="row review-margin">
                    <div class="col-lg-4">
                        <div class="review-item">
                            <span class="review-item-text">Cum sociis natoque penatibus et magnis dis parturienta montes, nascetur ridiculus mus. Curabitur a sem sollicitu.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                        <div class="review-item">
                            <span class="review-item-text">Cum sociis natoque penatibus et magnis dis parturienta montes, nascetur ridiculus mus. Curabitur a sem sollicitu.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                        <div class="review-item">
                            <span class="review-item-text">Cum sociis natoque penatibus et magnis dis parturienta montes.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                        <div class="review-item">
                            <span class="review-item-text">tai fiktyvus tekstas naudojamas spaudos ir grafinio dizaino pasaulyje jau nuo XVI a. pradžios. Lorem Ipsum tapo standartiniu fiktyviu tekstu, kai nežinomas spaustuvininkas atsitiktine tvarka išdėliojo raides.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="review-item">
                            <span class="review-item-text">tai fiktyvus tekstas naudojamas spaudos ir grafinio dizaino pasaulyje jau nuo XVI a. pradžios. Lorem Ipsum tapo standartiniu fiktyviu tekstu, kai nežinomas spaustuvininkas atsitiktine tvarka išdėliojo raides.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                        <div class="review-item">
                            <span class="review-item-text">Cum sociis natoque penatibus et magnis dis parturienta montes.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                        <div class="review-item">
                            <span class="review-item-text">Cum sociis natoque penatibus et magnis dis parturienta montes, nascetur ridiculus mus. Curabitur a sem sollicitu.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="review-item">
                            <span class="review-item-text">Cum sociis natoque penatibus et magnis dis parturienta montes.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                        <div class="review-item">
                            <span class="review-item-text">tai fiktyvus tekstas naudojamas spaudos ir grafinio dizaino pasaulyje jau nuo XVI a. pradžios. Lorem Ipsum tapo standartiniu fiktyviu tekstu, kai nežinomas spaustuvininkas atsitiktine tvarka išdėliojo raides.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                        <div class="review-item">
                            <span class="review-item-text">tai fiktyvus tekstas naudojamas spaudos ir grafinio dizaino pasaulyje jau nuo XVI a. pradžios. Lorem Ipsum tapo standartiniu fiktyviu tekstu, kai nežinomas spaustuvininkas atsitiktine tvarka išdėliojo raides.</span>
                            <div class="review-item-wrap">
                                <div class="review-item-img">
                                    <img src="~img/ava1.png" :alt="$t('meta.reviews.h1')"  :title="$t('meta.reviews.h1')">
                                </div>
                                <h4 class="review-item-name">mariukas, <br> finita įkūrėjas</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <try-it-section></try-it-section>

        <footer-component></footer-component>
    </div>
</template>

<script>
    import PrioritiesCarousel from '~cp/PrioritiesCarousel.vue'
    import TryItSection from '~cp/Public/PublicComponets/TryItSection.vue'

    export default {
        name: 'Reviews',
        components: {
            PrioritiesCarousel,
            TryItSection
        },
        data() {
            return {}
        },
        metaInfo() {
            return {
                title: this.$t('meta.reviews.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.reviews.description') },
                ]
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss">
    .review {
        padding-bottom: 70px;
        &-margin {
            margin-top: -35px;
        }
        &-item {
            background-color: #fff;
            padding: 28px 67px 15px 36px;
            border-radius: 5px;
            margin-bottom: 20px;
            &-text {
                color: #343434;
                font-size: 16px;
                line-height: 20px;
                display: block;
                margin-bottom: 15px;
                font-style: italic;
            }
            &-name {
                color: #b7b7b7;
                font-size: 10px;
                font-weight: 400;
                text-transform: uppercase;
                letter-spacing: 2px;
            }
            &-img {
                width: 42px;
                height: 42px;
                overflow: hidden;
                border-radius: 50%;
                margin-right: 13px;
                img {
                    max-width: 100%;
                    height: auto;
                    display: block;
                }
            }
            &-wrap {
                display: flex;
                align-items: center;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Public/Reviews.vue